module.exports = __webpack_public_path__ + "img/circle_red.4519c078.svg";